import {ActionContext} from "vuex";
import {IAppState} from "@/interfaces/app-state.interface";
import {Vue} from "vue-property-decorator";
import {httpResource} from "@/resources/http.resource";
import {IApp} from "@/interfaces/app.interface";
import {IAppTable} from "@/shared/AppTable/interfaces/sort-table-data";
import {IDeviceStats} from "@/modules/DeviceStats/interfaces/device-stats.interface";

type DeviceStatsStore = ActionContext<IDeviceStats.IState, IAppState>;

export const DeviceStatsStore: DeviceStatsStore = {
  // @ts-ignore
  namespaced: true,

  state: {
    tableData: [],
    loading: false,
    tableName: 'deviceStats',
    sortingTable: {
      prop: null,
      propType: IApp.SortingPropType.String,
      direction: IApp.SortDirection.Default,
    },
  },

  getters: {
    sortedList: (state: IDeviceStats.IState) => {
      return IAppTable.SortTableData({
        tableData: state.tableData,
        sortingTable: state.sortingTable,
        limitTotal: null,
      });
    },
  },

  mutations: {
    setProperty(state: IDeviceStats.IState, { name, value }: { name: string, value: any}) { Vue.set(state, name, value); },
    setSubProperty(state: IDeviceStats.IState, { block, name, value }: { block: string, name: string, value: any}) { Vue.set(state[block], name, value); },
    startLoading(state: IDeviceStats.IState) { state.loading = true },
    stopLoading(state: IDeviceStats.IState) { state.loading = false },
    setSorting(state: IDeviceStats.IState, cell: IAppTable.ITableProp) {
      let sortingData = IAppTable.SetSorting(state.sortingTable, cell, state.tableName);
      Vue.set(state, 'sortingTable', sortingData);
      IAppTable.ScrollTableToTop();
    },
  },

  actions: {
    async getDeviceStats({ state, commit, dispatch }: DeviceStatsStore, payload: { filters: any }) {
      let presetSorting = IAppTable.PresetStorageSorting(state.tableName);
      if (presetSorting) commit('setProperty', { name: 'sortingTable', value: presetSorting });

      commit('startLoading');
      let asyncAction = async () => {
        const action = IDeviceStats.Action.DeviceStats;
        let params: any = {
          command: IDeviceStats.Command.DeviceStats,
        };
        if (payload && payload.filters) {
          params = {
            ...params,
            ...payload.filters,
          }
        }

        const { data: { result: response }} = await httpResource.httpAction({ action, params });

        commit('setProperty', { name: 'tableData', value: response.deviceStats });
      };

      await dispatch('defaultResourceAction', { asyncAction }, { root: true });
      commit('stopLoading');
    },
  }
};
